import { render, staticRenderFns } from "./ideaResult.vue?vue&type=template&id=28e0f687&scoped=true"
import script from "./ideaResult.vue?vue&type=script&lang=js"
export * from "./ideaResult.vue?vue&type=script&lang=js"
import style0 from "./ideaResult.vue?vue&type=style&index=0&id=28e0f687&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e0f687",
  null
  
)

export default component.exports